import { Vue, Component, Prop } from 'vue-property-decorator';
import { contentAPI } from '@/providers/apis/content-ingestion/content-ingestion';
import { sessionService } from '@/providers/services/auth/session';

@Component({
  name: 'upload-status-component',
})
export default class UploadStatusComponent extends Vue {
  // ----------------------------------------------------------------------
  // Properties

  @Prop()
  public id!: string;

  public itemsOffset = 0;
  public itemsLimit = 10;
  public page = 1;
  public totalLength: number = 0;
  public contentItems: any = [];
  public filterDetails: any = {};
  public loader: boolean = false;
  public validationReason: string = '';

  private itemsField: any = [
    {
      key: 'uniqueId',
      label: 'Unique Id',
      sortable: false,
      thClass: 'text-center',
      tdClass: 'text-center',

    },
    {
      key: 'validationFailedReason',
      label: 'Failed Reasons',
      sortable: false,
      thClass: 'text-center',
    },
  ];

  // ---------------------------------------------------------------------
  // Hooks

  // methods
  public mounted() {
    this.filterDetails.offset = 0;
    this.filterDetails.limit = this.itemsLimit;
    this.filterDetails.content_ingest_request_id = this.id;
    this.filterDetails.user_id = this.getUserId();
    this.getContentItems();
  }

  public getUserId() {
    const userDetails: any = sessionService.getSession();
    return userDetails.user_id;
  }

  // Get content-Items
  public loadItemsContent(page: number) {
    this.page = page;
    this.itemsLimit = 10;
    const items = this.itemsLimit * this.page;
    if (items >= this.contentItems.length) {
      this.itemsOffset = this.contentItems.length;
      this.itemsLimit = this.itemsLimit * this.page - this.contentItems.length;
      this.filterDetails.offset = this.itemsOffset;
      this.filterDetails.limit = this.itemsLimit;
      this.getContentItems();
    }
  }

  public getContentItems() {
    this.loader = true;
    this.filterDetails.validation_status = 'failed';
    contentAPI.uploadFileItems(this.filterDetails).then((response) => {
      this.totalLength = response.count;
      this.contentItems = this.contentItems.concat(response.contentIngestItems);
      this.loader = false;
    });
  }

  // Actions
  public close() {
    this.$bvModal.hide('modal-center');
  }
}
